import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "../../../styles";
import { rtlRotate180 } from "../../../styles/utils.css";
import { buttonStyles } from "../../buttons/Button/Button.recipe";

const outlinedBase = buttonStyles({ appearance: "outlined" });

export const paginatorButton = styleVariants({
  single: [
    outlinedBase,
    {
      borderRadius: vars.radii.full,
      padding: vars.space.xs,
    },
  ],
  text: [
    outlinedBase,
    {
      padding: `${vars.space.s} ${vars.space.s} ${vars.space.s} ${vars.space.m}`,
      fill: vars.colors.onSurface,
      selectors: {
        "&:hover": {
          fill: vars.colors.onSurface,
        },
      },
    },
  ],
  double: [
    outlinedBase,
    {
      borderRadius: vars.radii.full,
      padding: `${vars.space.xs} ${vars.space.s}`,
    },
  ],
});

export const textButtonIcon = style([
  rtlRotate180,
  {
    width: 18,
    height: 18,
  },
]);
